import { Box } from 'js/component/base/box';
import { colors } from 'js/theme/colors';
import { typography } from 'js/theme/typography';
import React from 'react';
import styled from 'styled-components';

export const BrowserWarning = () => {
  return (
    <Container>
      <MessageTitleLabel>This browser is not supported.</MessageTitleLabel>
      <MessageLabel>
        Please use Google Chrome, Firefox or Microsoft Edge for the best experience.
      </MessageLabel>
    </Container>
  );
};

const Container = styled(Box)`
  display: block;
  margin: 24px;

  > * {
    color: ${colors.white};
  }
`;

const MessageTitleLabel = styled.div`
  margin-bottom: 24px;
  display: block;
  ${typography.med['4']};
`;
const MessageLabel = styled.div`
  ${typography.book['2']};

  a {
    ${typography.book['2']};
    padding: 0 5px;
  }
`;
